import React from "react";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";

import { reverse } from "@reactivated";

import { check } from "../../../models/utils";
import { usePageURL } from "../../../utils/urls";
import {
    IModularConfiguratorOptionSet,
    ModularConfiguratorOptionSet,
} from "../models";
import { Configurator, IProps as IConfiguratorProps } from "./Configurator";

interface IProps {
    optionSetJSON: string;
    passthroughProps?: Partial<IConfiguratorProps>;
}

export const ModularConfigurator = (props: IProps): React.ReactNode => {
    const optionSet: IModularConfiguratorOptionSet = check(
        ModularConfiguratorOptionSet.decode(JSON.parse(props.optionSetJSON)),
    );

    const financeLink = usePageURL("finance_link");
    const homeLink = usePageURL("home");
    const financingLink = financeLink || homeLink;

    return (
        <Configurator
            optionSet={optionSet}
            financingLink={financingLink}
            basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
            favoritesLink={isoWebPageURL.wrap(reverse("basket:summary"))}
            configureGiftsLink={isoWebPageURL.wrap(
                reverse("basket:configure-gifts"),
            )}
            {...props.passthroughProps}
        />
    );
};
